import type {Step} from "./Step.ts";
import Styles from "./Styles.module.scss"
import {combineStyles} from "../../util/combineStyles.ts";
import {Tooltip} from "@matillion/component-library";

interface Props {
    steps: Step[],
    currentStep: number
    setCurrentStep: (step: number) => void
    locked: boolean
}
export function StepsDisplay({steps, currentStep, setCurrentStep, locked}: Props) {
    return <div className={Styles.StepBox}>
        {steps.map((step, index) => {
            const isCurrentStep = currentStep === index
            const isAvailable = step.isAvailable
            const isCompleted = step.isCompleted
            const styles = combineStyles(
                Styles.Step,
                isAvailable ? undefined : Styles.Unavailable,
                isCompleted ? Styles.Completed : undefined,
                isCurrentStep ? Styles.Current : undefined
            )
            return <>
                <div key={step.name} className={styles} onClick={() => setCurrentStep(index)}>
                    <div>
                        {step.name}
                        {locked && isCurrentStep && <Tooltip content={"This step is currently locked. Refresh to cancel"}><span>🔒</span></Tooltip>}
                    </div>
                </div>
                {index < steps.length - 1 && <div className={Styles.Divider}></div>}
            </>

        })}
    </div>
}